@let profile = loggedInProfile();

@if (profile) {
  @if (showGreeting()) {
    <fin-greeting-card [firstName]="profile.firstname" [isMultiPax]="isMultiPax()" />
  }
} @else if (loginStatus() === LoginStatus.NOT_LOGGED_IN) {
  <fin-login-card
    [title]="'loginPromotion.loginHeading.inPaxDetails'"
    [benefitText]="'loginPromotion.benefitText'"
    [footnoteText]="'loginPromotion.footNote'"
    [showIcon]="false"
    [benefitMode]="'list'"
  />
}
